import _Tooltip from "@mui/material/Tooltip";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import React from 'react';
import { SponsorIcon } from './icons';
export function SponsorBadge({
  size
}) {
  return /*#__PURE__*/React.createElement(_Tooltip, {
    title: "Cette entreprise est engag\xE9e ! Sa souscription au challenge permet le financement des actions Team for the Planet"
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    bgcolor: "#eee8fd",
    borderRadius: 2,
    display: "flex",
    gap: 0.5,
    paddingX: 1,
    paddingY: 0.5
  }, /*#__PURE__*/React.createElement(SponsorIcon, {
    sx: size === 'small' ? {
      height: 14,
      width: 14
    } : {}
  }), /*#__PURE__*/React.createElement(_Typography, {
    color: "#6236bd",
    lineHeight: "14px",
    variant: size === 'small' ? 'caption' : 'body2'
  }, "Sponsor")));
}